import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

import { Mask } from '@hapvida/hapvida-core-components';

import { useAuth } from '@hooks';
import { CompanySetupListRouter } from '@flows/private/companySetup/pages/CompanySetupList/router';

import { HeaderItem } from '../HeaderItem';
import { SelectedCompanyMobile } from './components/SelectedCompany';

export function SelectedCompany() {
  const { selectedCompany } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(CompanySetupListRouter.path);
  }, [navigate]);

  if (!selectedCompany) {
    return null;
  }

  const { legal, name, document } = selectedCompany;
  const companyLabel = legal ?? name;
  const documentLabel = Mask.cnpj(document, true);

  return (
    <>
      {isMobile ? (
        <SelectedCompanyMobile
          companyLabel={companyLabel}
          documentLabel={documentLabel}
          onClick={onClick}
        />
      ) : (
        <HeaderItem onClickEdit={onClick}>
          <Typography variant="text" title={companyLabel} fontWeight={900}>
            {companyLabel}
          </Typography>
          <Typography variant="text" fontWeight={900}>
            —
          </Typography>
          <Typography minWidth="125px" variant="text">
            {documentLabel}
          </Typography>
        </HeaderItem>
      )}
    </>
  );
}
